import './App.css';
import './components/formStyleSheet/FormStyling.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-quill/dist/quill.snow.css';
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import Router from './routes/Routes';
import { useEffect } from 'react';
import { placeholderimg } from './assets/imagesPath';

const App = () => {

  useEffect(() => {
    const handleImageError = (e) => {
      if (e.target.tagName === 'IMG') {
        e.target.src = placeholderimg;
        e.target.onerror = null;
      }
    };

    document.addEventListener('error', handleImageError, true);

    return () => {
      document.removeEventListener('error', handleImageError, true);
    };
  }, []);

  useEffect(() => {
    const handleGlobalNumberInput = (event) => {
      if (event.target.type === "number") {
        const value = event.target.value;
        if (value <= 0) {
          event.target.value = "";
        }
      }
    };

    const preventScrollOnWheel = (event) => {
      if (event.target.type === "number") {
        event.preventDefault();
      }
    };

    document.addEventListener("input", handleGlobalNumberInput);
    document.addEventListener("wheel", preventScrollOnWheel, { passive: false });

    return () => {
      document.removeEventListener("input", handleGlobalNumberInput);
      document.removeEventListener("wheel", preventScrollOnWheel);
    };
  }, []);

  useEffect(() => {
    if (window.FB) return;

    window.fbAsyncInit = function () {
      window.FB.init({
        appId: '1226200508882462',
        cookie: true,
        xfbml: false,
        version: 'v23.0',
      });
    };

    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }, []);

  return (
    <Router />
  );
};

export default App;